import React from 'react';
import EVerifyEmail from '../EVerifyEmail';

const PROGRAM_NAME = 'E-Verify+';

const EvePlusTermsOfService = ({ nawToAawToggle }: { nawToAawToggle: string }): JSX.Element => {
  return (
    <div className="grid-col-12 tablet:grid-col-9 desktop:grid-col-9">
      <p>
        Before participating in <span className="text-no-wrap">{PROGRAM_NAME}</span>, the participating employer, or an
        authorized agent of the participating employer, must read, agree with, and accept all the terms and conditions
        contained in these Terms of Service. Failure to comply with these Terms of Service may lead to legal liability,
        suspension, or termination from <span className="text-no-wrap">E-Verify</span> and{' '}
        <span className="text-no-wrap">{PROGRAM_NAME}</span>.
      </p>
      <h4>
        About <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>
      </h4>
      <p>
        <span className="text-no-wrap">E-Verify</span> is a Department of Homeland Security (DHS) program operated in
        cooperation with the Social Security Administration (SSA) that permits participants to electronically confirm
        the eligibility of individuals to work in the United States. <span className="text-no-wrap">E-Verify</span>{' '}
        compares information from an employee’s Form I-9, Employment Eligibility Verification, to data from government
        data systems to confirm identity and employment eligibility.
      </p>
      <p>
        In these Terms of Service, persons and other entities that enroll in and use{' '}
        <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> are
        called “participants.” The Form I-9 generated by <span className="text-no-wrap">{PROGRAM_NAME}</span> is labeled
        “Form I-9NG”. <span className="text-no-wrap">{PROGRAM_NAME}</span> references to “Form I-9” in these Terms of
        Service also refer to the Form I-9NG.
      </p>
      <p>
        <span className="text-no-wrap">E-Verify</span> is authorized by Title IV, Subtitle A, of the Illegal Immigration
        Reform and Immigrant Responsibility Act of 1996 (IIRIRA), Pub. L. 104-208, 110 Stat. 3009, as amended (8 U.S.C.
        § 1324a note). The Federal Acquisition Regulation (FAR) Subpart 22.18, “Employment Eligibility Verification” and
        Executive Order 12989, as amended, require covered Federal contractors and subcontractors (“Federal
        contractors”) to use <span className="text-no-wrap">E-Verify</span> to confirm the employment eligibility of
        certain individuals working on Federal contracts. Airport Operators may use{' '}
        <span className="text-no-wrap">E-Verify</span> in accordance with the Federal Aviation Administration Extension,
        Safety and Security Act of 2016, Pub. L. No. 114-190, § 3405(d) when determining eligibility for unescorted
        access to any security identification display area of an airport.
      </p>
      <p>
        <span className="text-no-wrap">{PROGRAM_NAME}</span> is a service of{' '}
        <span className="text-no-wrap">E-Verify</span> that allows a participant to electronically initiate the
        employment verification process for their recently hired employees, prompting the employee to create and log in
        to their <span className="text-no-wrap">{PROGRAM_NAME}</span> account, enter their Form I-9 information, and
        have that information electronically confirmed by <span className="text-no-wrap">E-Verify</span>. The result is
        transmitted to the <span className="text-no-wrap">{PROGRAM_NAME}</span> participating employer for creation and
        retention of a Form I-9 (labeled Form I-9NG) after physical examination or by using the DHS-authorized
        alternative procedure for remote examination of documentation.
      </p>
      <p>
        <span className="text-no-wrap">{PROGRAM_NAME}</span> is authorized by section 274A(d)(4) of the Immigration and
        Nationality Act (INA) (8 U.S.C. § 1324a(d)(4)) and Executive Order 12781 (Nov. 20, 1991) as a demonstration
        project undertaken by the Secretary of Homeland Security.
      </p>
      <p>
        When a participant confirms the identity and employment eligibility of a newly hired employee using{' '}
        <span className="text-no-wrap">E-Verify</span> through <span className="text-no-wrap">{PROGRAM_NAME}</span>, it
        establishes a rebuttable presumption that it has not violated section 274A(a)(1)(A) of the INA (8 U.S.C. §
        1324a(1)(A)), with respect to the hiring of that individual. A participant that receives a final nonconfirmation
        regarding an individual from <span className="text-no-wrap">E-Verify</span> through{' '}
        <span className="text-no-wrap">{PROGRAM_NAME}</span> may terminate the individual’s employment. If the
        participant does not terminate the individual’s employment, it must notify DHS through{' '}
        <span className="text-no-wrap">{PROGRAM_NAME}</span> of the individual’s continued employment. Each failure to
        notify DHS that an individual continues to be employed after receiving a final nonconfirmation from{' '}
        <span className="text-no-wrap">E-Verify</span> through <span className="text-no-wrap">{PROGRAM_NAME}</span> is a
        violation of INA section 274A(a)(1)(B) and may subject the participant to civil or criminal penalties, money
        penalty, among other sanctions. A participant that continues to employ any individual after receiving a final
        nonconfirmation from <span className="text-no-wrap">E-Verify</span> through{' '}
        <span className="text-no-wrap">{PROGRAM_NAME}</span> is subject to a rebuttable presumption that the person or
        entity has knowingly employed an unauthorized <span className="text-no-wrap">{nawToAawToggle}</span> in
        violation of INA section 274A(a)(1)(A). No <span className="text-no-wrap">E-Verify</span> or{' '}
        <span className="text-no-wrap">{PROGRAM_NAME}</span> participant may be held civilly or criminally liable under
        any law for any action taken in good faith reliance on information provided through{' '}
        <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span>.
      </p>
      <h4>A. Accepted Uses</h4>
      <p>Participants who acknowledge and accept these Terms of Service agree to:</p>
      <ol>
        <li>
          Use <span className="text-no-wrap">E-Verify</span>, <span className="text-no-wrap">{PROGRAM_NAME}</span> and
          any related service as directed by Federal law and regulation, Executive Order, and these Terms of Service;
          and become familiar with, follow, and certify understanding and acceptance of the most recent{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> guidance and{' '}
          <span className="text-no-wrap">E-Verify</span> user manual(s), supplements, agency guidance, and tutorials.
        </li>
        <li>
          Ensure that each user completes and certifies to completing the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> training video before that user creates an{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> case.
        </li>
        <li>
          Provide true, accurate, current, legible, and complete information about themselves and their entity, as
          prompted by <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> during enrollment or enablement, through management of
          their account, or as otherwise requested by DHS.
        </li>
        <li>
          Obtain and commit the necessary equipment, personnel, and resources to use{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> as required, or designate an agent with the necessary
          equipment, personnel, and resources to fulfill the participant’s responsibilities under these Terms of
          Service.
        </li>
        <li>
          Grant <span className="text-no-wrap">{PROGRAM_NAME}</span> access only to registered users to create cases
          and/or administer <span className="text-no-wrap">{PROGRAM_NAME}</span>; provide true, accurate, current
          legible, and complete information (including names, titles, addresses, email addresses and telephone numbers)
          about anyone who will be using, accessing or administering{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> on the participant’s behalf; and promptly terminate the
          access of anyone registered to use, access or administer <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          who separates from the participant or no longer needs access to{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>.
        </li>
        <li>
          Ensure that any <span className="text-no-wrap">{PROGRAM_NAME}</span> user is trained on current{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          policies and procedures and completes and certifies to completion of all required{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          tutorials or training videos, including any refresher tutorials, before creating any{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> cases.
        </li>
        <li>
          Comply with current Form I-9 laws, regulations, and procedures, including as applicable and if qualified, a
          DHS-authorized alternative procedure, to complete, retain and make available for inspection its Forms I-9,
          with two exceptions:
        </li>
        <li>
          If an individual presents a List B identity document for Form I-9, the participant agrees to only review and
          verify List B documents that contain a photo (List B documents identified in 8 C.F.R. § 274a.2(b)(v)(1)(B) can
          be presented during the Form I-9 process to establish identity).
        </li>
        <li>
          If an individual presents a Form I-551 (Permanent Resident Card), Form I-766 (Employment Authorization
          Document), or U.S. passport or passport card for Form I-9, the participant agrees, if a copy of the document
          is not already found in <span className="text-no-wrap">{PROGRAM_NAME}</span>, to copy the document and retain
          the copy with the individual’s Form I-9. Participants will use the document or a photocopy to verify the photo
          and to assist DHS with its review of photo mismatches that individuals take action to resolve. These same
          requirements apply to any documents that DHS may designate in the future to activate the photo screening tool.
          <strong>Note:</strong> Subject only to the exceptions noted previously in this paragraph, individuals still
          have the right to present any List A, or List B and List C document(s) to complete Form I-9.
        </li>
        <li>
          Provide all individuals to be verified using <span className="text-no-wrap">{PROGRAM_NAME}</span> with a
          hyperlink supplied by <span className="text-no-wrap">{PROGRAM_NAME}</span> to initiate the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> confirmation process after extending an offer and
          receiving an acceptance of that offer from the individual. The individual will utilize that hyperlink to
          create an <span className="text-no-wrap">{PROGRAM_NAME}</span> account or log in to their existing{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> account.
        </li>
        <li>
          In those instances where the individual declines to use <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          or <span className="text-no-wrap">{PROGRAM_NAME}</span> is otherwise unavailable, complete the Form I-9 and
          physically examine Form I-9 documents or employ the DHS-authorized alternative procedure for remote
          examination of such documents before using <span className="text-no-wrap">E-Verify</span>, pursuant to all
          terms and conditions applicable to <span className="text-no-wrap">E-Verify</span>.
        </li>
        <li>
          No later than the date of hire, ensure that all individuals being verified complete and attest to completion
          of the Form I-9 through <span className="text-no-wrap">{PROGRAM_NAME}</span>. If the employee agrees to use{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>, within three business days after the individual begins
          work for pay, the individual must enter document information and upload legible copies of acceptable
          documentation into <span className="text-no-wrap">{PROGRAM_NAME}</span> and submit to their employer through{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>.
        </li>
        <li>
          Completes an <span className="text-no-wrap">{PROGRAM_NAME}</span> case for all newly hired individuals within
          three business days after the individual has been hired (i.e., Form I-9, Section 2 and physical examination,
          or DHS-authorized alternative procedure for remote examination of documentation, have been completed and
          attested to by the participant in <span className="text-no-wrap">{PROGRAM_NAME}</span>), except as otherwise
          permitted by law, the <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) or other agency guidance. If a social
          security number is not currently available, please see{' '}
          <a
            href="https://www.e-verify.gov/faq/my-employee-applied-for-a-social-security-number-ssn-but-has-not-yet-received-it-what-should-i"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Click here to open E-Verify Guidance in a new tab"
          >
            <span className="text-no-wrap">E-Verify</span> guidance.
          </a>
        </li>
        <li>
          Allow the individual to follow all required <span className="text-no-wrap">{PROGRAM_NAME}</span> procedures
          for processing cases, tentative non-confirmations (“mismatches”) and final non-confirmations in the electronic
          confirmation processes, including but not limited to:
        </li>
        <li>permitting the individual to take action to resolve the mismatch;</li>
        <li>permitting the individual to continue working while they are taking action to resolve the mismatch;</li>
        <li>
          not taking any adverse action against an individual who has decided to take action to resolve a mismatch,
          based on the mismatch. The individual may not be terminated or suffer any adverse employment consequences
          based upon the employee’s perceived employment eligibility status (including denying, reducing, or extending
          work hours, delaying or preventing training, requiring an employee to work in poorer conditions, withholding
          pay, refusing to assign the employee to a Federal contract or other assignment, or otherwise assuming that he
          or she is unauthorized to work) until and unless secondary verification by SSA or DHS has been completed and a
          final nonconfirmation has been issued. If a final nonconfirmation is issued, the individual may be terminated.
        </li>
        <li>
          checking the <span className="text-no-wrap">{PROGRAM_NAME}</span> system regularly for case updates and
          results;
        </li>
        <li>
          notifying DHS through <span className="text-no-wrap">{PROGRAM_NAME}</span> when an individual continues to be
          employed after receiving a final nonconfirmation from <span className="text-no-wrap">E-Verify</span> through{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>; and
        </li>
        <li>
          closing cases when a final response has been received or the individual’s employment is terminated.
          <strong>Note:</strong> <span className="text-no-wrap">{PROGRAM_NAME}</span> will furnish a mismatch notice to
          the individual on the participant’s behalf and will notify the participant of that delivery. By participating
          in <span className="text-no-wrap">{PROGRAM_NAME}</span>, the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participant agrees that DHS is merely facilitating the
          delivery of the notice to the individual and that the participant retains responsibility for the individual’s
          receipt of the notice. <span className="text-no-wrap">{PROGRAM_NAME}</span> participants who fail to notify
          DHS that an individual continues to be employed after receiving a final nonconfirmation from{' '}
          <span className="text-no-wrap">E-Verify</span> through <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          may be found in violation of INA 274A(a)(1)(B) and may be subject to a civil money penalty under INA
          274A(e)(5) and/or criminal penalty for each failure to notify DHS.
        </li>
        <li>
          Except as required by law or for legitimate purposes authorized in advance in writing by DHS, ensure
          information received from <span className="text-no-wrap">{PROGRAM_NAME}</span> is used only to confirm
          identity and employment eligibility, and is disseminated only to authorized individuals.
        </li>
        <li>
          Immediately notify DHS in the event of a suspected or confirmed breach of personal information. “Breach” is
          defined as the loss of control, compromise, unauthorized disclosure, unauthorized acquisition, or any similar
          occurrence where: (1) a person other than an authorized user accesses or potentially accesses personally
          identifiable information; or (2) an authorized user accesses or potentially accesses personally identifiable
          information for any other than authorized purpose. All suspected or confirmed breaches should be reported by
          calling 1-888-464-4218 (TTY 877-875-6028) or by emailing{' '}
          <a
            href="mailto:E-Verify@uscis.dhs.gov"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Click here to send an email to E-Verify@uscis.dhs.gov in a new tab"
          >
            <span className="text-no-wrap">E-Verify</span>@uscis.dhs.gov
          </a>
          . Please type “Privacy Incident” in the subject line of your email when sending a breach report to{' '}
          <span className="text-no-wrap">E-Verify</span>. Federal, state law, local law, or regulation may impose
          additional notification or reporting requirements.
        </li>
        <li>
          Fully cooperate with DHS and other authorized agencies in their compliance monitoring and evaluation of{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          including permitting DHS, other authorized agencies, and their contractors and other agents, upon reasonable
          notice, to review Forms I-9, all supporting documentation, and Form I-9 electronic generation, retention and
          storage records and audit trails as well as other employment records such as payroll and wage and hour
          records, conduct site visits, and to interview your current and former employees and{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> users
          regarding their use of <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>.
        </li>
        <li>
          Respond promptly and accurately to DHS requests for information relating to{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          participation.
        </li>
        <li>
          Use <span className="text-no-wrap">{PROGRAM_NAME}</span> only for individuals hired to work within the 50
          States, the District of Columbia, Puerto Rico, the U.S. Virgin Islands, Guam, and the Commonwealth of the
          Northern Mariana Islands.
        </li>
      </ol>
      <h4>
        B. <span className="text-no-wrap">{PROGRAM_NAME}</span> Service and Access
      </h4>
      <ol>
        <li>
          <span className="text-no-wrap">{PROGRAM_NAME}</span> is an official United States government system that may
          be used only for authorized purposes. Every effort is made to ensure the quality, integrity, and utility of
          the information in the system while ensuring privacy and security. Failure to comply with these Terms of
          Service may be considered a security incident under DHS policy. If an{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participant is involved in a security incident, that
          participant’s <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> user accounts, affiliated sub-accounts, usernames and
          passwords may be temporarily or permanently disabled, suspended or removed with or without prior notice,
          effectively revoking all access to <span className="text-no-wrap">E-Verify</span>,{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>, any <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          username and password, and any or all <span className="text-no-wrap">E-Verify</span> or{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> data.
        </li>
        <li>
          Unauthorized access of <span className="text-no-wrap">{PROGRAM_NAME}</span> and its related systems is a
          violation of the laws of the United States and DHS policies and may result in administrative, civil, or
          criminal penalties. <span className="text-no-wrap">{PROGRAM_NAME}</span> participants, including unauthorized
          users, must not attempt to access information, files, or system files not within their account without prior
          authorization from DHS. Absence of security access controls is not an authorization to access or a waiver of
          applicable laws, regulations, or DHS policies.
        </li>
        <li>
          The participant acknowledges that the information it receives from SSA is governed by the Privacy Act (5
          U.S.C. § 552a(i)(1) and (3)) and the Social Security Act (42 U.S.C. 1306(a)). Any person who obtains this
          information under false pretenses or uses it for any purpose other than as provided for in these Terms of
          Service may be subject to criminal penalties.
        </li>
        <li>
          <span className="text-no-wrap">E-Verify</span> participants may access{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> via the internet through the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> website or may choose to have an agent access{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>, or to develop or purchase Web Services software to
          access <span className="text-no-wrap">{PROGRAM_NAME}</span>. Additional terms and conditions may apply to{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> use
          through an agent or through Web Services access.
        </li>
        <li>
          DHS does not charge transaction fees to use the <span className="text-no-wrap">{PROGRAM_NAME}</span> GUI;
          however, <span className="text-no-wrap">E-Verify</span> participants may be subject to costs for equipment,
          internet services or other costs associated with accessing the internet or for the purchase, development or
          maintenance of Web Services software or <span className="text-no-wrap">E-Verify</span> Employer Agent services
          used to access <span className="text-no-wrap">{PROGRAM_NAME}</span>. DHS does not reimburse these fees and
          costs.
        </li>
        <li>
          DHS does not endorse any <span className="text-no-wrap">E-Verify</span> or{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> Employer Agents, Web Services software or other software
          providers. <span className="text-no-wrap">{PROGRAM_NAME}</span> participants who choose to use{' '}
          <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          Employer Agents, Web Services software or other software providers to access{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> accept the risks of such use.
        </li>
        <li>
          DHS does not guarantee the availability or operability of <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>. DHS is not liable to{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participants for their inability to perform their
          obligations by reason of natural disaster; lack of approved funding; a government shutdown; any failure or
          delay of any power, computer, or communications system; or any other cause beyond its control.
        </li>
        <li>
          If an <span className="text-no-wrap">{PROGRAM_NAME}</span> participant causes a technical disruption of the
          site or the systems transmitting the site to the <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          participant, or to others by intentional or grossly negligent acts, the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participant shall be responsible for any and all civil
          and/or criminal penalties, including but not limited to attorney’s fees, actual and consequential damages
          arising from the disruption of the sites, and all effort taken to correct and restore the site.
        </li>
        <li>
          If <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span> is
          temporarily unavailable, the required time periods for creating cases and resolving mismatches and final
          nonconfirmations may be extended until <span className="text-no-wrap">E-Verify</span> or{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> is again operational and, in some cases, for a period
          thereafter, as determined by DHS, in order to accommodate the participant’s attempts, in good faith, to make
          inquiries during the period of unavailability. Employers must continue to complete and retain a Form I-9 for
          every individual hired to work for pay in the U.S. within the required timeframes. Participants using an{' '}
          <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          Employer Agent, an Employee Agent or other enrolled Web Services provider have the option to use the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> GUI or, after notifying DHS, an alternate enrolled Web
          Service provider in the event of Web Service provider unavailability. Under no circumstances should both an{' '}
          <span className="text-no-wrap">E-Verify</span> case and an{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> case be created on behalf of the same individual based on
          the same hiring event. If an individual was hired during the unavailability of{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>, and
          the participant creates an <span className="text-no-wrap">E-Verify</span> case after either{' '}
          <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span> becomes
          available, the participant agrees not to initiate an <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          case.
        </li>
        <li>
          In using <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>, and any <span className="text-no-wrap">E-Verify</span>{' '}
          and <span className="text-no-wrap">{PROGRAM_NAME}</span> services later developed, the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participant understands and agrees that:
        </li>
        <li>
          Access to <span className="text-no-wrap">{PROGRAM_NAME}</span> is at DHS discretion and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> use is subject to continuous monitoring in accordance
          with DHS policy.
        </li>
        <li>
          Participants will not circumvent or attempt to circumvent any passwords, security measures or safeguards, or
          alter any <span className="text-no-wrap">{PROGRAM_NAME}</span> or affiliated web pages.
        </li>
        <li>
          Each <span className="text-no-wrap">{PROGRAM_NAME}</span> account username and password will be unique,
          associated directly with a single individual, and not transferred between individuals. In addition, an{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> user will only maintain one user account for each
          participant account for which he or she is an authorized representative.
        </li>
        <li>
          The <span className="text-no-wrap">{PROGRAM_NAME}</span> participant and its users will take all reasonable
          measures to protect their usernames and passwords, and immediately report to DHS the loss or compromise of any
          username or password.
        </li>
        <li>
          Neither the <span className="text-no-wrap">{PROGRAM_NAME}</span> participant nor its users will copy any
          username or password, nor allow any username or password to be used by any other person unless authorized.
        </li>
        <li>
          The <span className="text-no-wrap">{PROGRAM_NAME}</span> participant and its users will change or immediately
          request revocation of usernames or passwords if: (i) the <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          access information is insecure in any way; or (ii) any of the information contained in the username or
          password has been changed by someone other than the account owner.
        </li>
        <li>
          Neither the <span className="text-no-wrap">{PROGRAM_NAME}</span> participant nor its users will process any
          individual’s information in <span className="text-no-wrap">{PROGRAM_NAME}</span> unless authorized by these
          Terms of Service.
        </li>
        <li>
          Any device a participant uses to access <span className="text-no-wrap">{PROGRAM_NAME}</span> will have
          appropriate security controls installed and activated, and the latest updates applied.
        </li>
        <li>
          DHS will dispose of <span className="text-no-wrap">{PROGRAM_NAME}</span> employee and employer account data
          pursuant to the approved NARA retention schedule, i.e., data that is 10 years old or older.
        </li>
      </ol>
      <h4>C. Prohibited Uses</h4>
      <p>Participants who acknowledge and accept these Terms of Service agree that they shall not:</p>
      <ol>
        <li>
          Access or use <span className="text-no-wrap">{PROGRAM_NAME}</span> in violation of any Federal law or
          regulation, Executive Order, these Terms of Service, or the current{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> user
          manual(s) and agency guidance.
        </li>
        <li>
          Provide an <span className="text-no-wrap">{PROGRAM_NAME}</span> case creation hyperlink before an individual
          has been extended and accepted an offer of employment.
        </li>
        <li>
          Use <span className="text-no-wrap">{PROGRAM_NAME}</span> to screen job applicants prior to hire, to support
          any unlawful employment practice, or for any other use not authorized by these Terms of Service, the{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> user
          manual(s) or other agency guidance.
        </li>
        <li>
          Require a second electronic confirmation using <span className="text-no-wrap">{PROGRAM_NAME}</span> or{' '}
          <span className="text-no-wrap">E-Verify</span> of any individual who has previously been electronically
          confirmed under these Terms of Service or the participant’s <span className="text-no-wrap">E-Verify</span> MOU
          or to authorize electronic confirmation of any existing employee by any Employer, except as otherwise
          permitted by law, rule, regulation, or policy.
        </li>
        <li>
          Use <span className="text-no-wrap">{PROGRAM_NAME}</span> in a discriminatory manner against any individual in
          hiring, firing, employment eligibility verification or reverification, or recruitment or referral practices
          because of their national origin or citizenship status, or other prohibited basis (such as race, age, sex, or
          religion), or by committing discriminatory documentary practices. In particular:
        </li>
        <li>
          Use of <span className="text-no-wrap">{PROGRAM_NAME}</span> in a manner that violates the anti-discrimination
          provision of the INA, 8 U.S.C. § 1324b, may subject the <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          participant to civil penalties, back pay awards, suspension or termination from{' '}
          <span className="text-no-wrap">E-Verify</span> and other sanctions. <strong>Note:</strong> If a participant
          has any questions relating to these anti-discrimination provisions, they should contact the Department of
          Justice Immigrant and Employee Rights Section at 1-800-255-8155 or 1-800-237-2515 (TDD).
        </li>
        <li>
          Use of <span className="text-no-wrap">{PROGRAM_NAME}</span> in a manner that violates Title VII of the Civil
          Rights Act of 1964 may subject the participant to back pay, compensatory and punitive damage awards,
          suspension or termination from participation in <span className="text-no-wrap">E-Verify</span>, and other
          sanctions. <strong>Note:</strong> If a participant has any questions relating to these anti-discrimination
          provisions, they should contact the Department of Justice Immigrant and Employee Rights Section at
          1-800-255-8155 or 1-800-237-2515 (TDD).
        </li>
        <li>
          Selectively verify individuals or verify individuals hired before the effective date of the participant’s
          enrollment in <span className="text-no-wrap">{PROGRAM_NAME}</span>.{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participants who are Airport Operators or Federal
          Contractors may qualify for exceptions to this requirement as described in regulations and the{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> user
          manual(s) and agency guidance.
        </li>
        <li>
          Take any adverse action against an individual, unless otherwise authorized or required by law, based on the
          participant’s perception of the individual’s employment eligibility while SSA or DHS is processing an
          electronic confirmation request.
        </li>
        <li>
          Make any false or unauthorized claims about <span className="text-no-wrap">{PROGRAM_NAME}</span> participation
          on its website, in advertising materials, or in other media. The participant will not describe its services as
          federally approved, federally certified, or federally recognized, or use other similar language to imply DHS
          approval or endorsement.
        </li>
        <li>
          Use <span className="text-no-wrap">{PROGRAM_NAME}</span> in any other manner that these Terms of Service or
          other <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          policies or procedures do not authorize.
        </li>
      </ol>
      <h4>D. Accessibility</h4>
      <ol>
        <li>
          <span className="text-no-wrap">E-Verify</span> recognizes the importance of being able to communicate
          effectively with individuals with limited English proficiency and individuals with disabilities.{' '}
          <span className="text-no-wrap">E-Verify</span> is committed to providing individuals with disabilities access
          to our webpages. To meet this commitment, <span className="text-no-wrap">{PROGRAM_NAME}</span> complies with
          the requirements of Section 508 of the Rehabilitation Act of 1973, as amended (29 U.S.C. § 794d). Read more on
          the <span className="text-no-wrap">E-Verify</span> Accessibility policy at{' '}
          <a
            href="https://www.e-verify.gov/key-links/website-policies/accessibility"
            aria-label="Click here to open the E-Verify accessibility page in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            E-Verify Accessibility
          </a>
          . In addition, the Americans with Disabilities Act of 1990 (42 U.S.C. § 12101) requires that participants
          communicate effectively with applicants and employees who have communication disabilities. See{' '}
          <a
            href="https://www.ada.gov/resources/effective-communication/"
            aria-label="Click here to open the ADA Requirements: Effective Communication page in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.ada.gov/resources/effective-communication/
          </a>{' '}
          for more information.
        </li>
      </ol>
      <h4>E. Trademarks and Logos</h4>
      <ol>
        <li>
          Nothing in these Terms of Service shall be interpreted as authorization to use the official seal, insignia or
          other visual identities of DHS, USCIS, <span className="text-no-wrap">E-Verify</span>,{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> or any other{' '}
          <span className="text-no-wrap">E-Verify</span> service (for example,{' '}
          <span className="text-no-wrap">myE-Verify</span>). Participants shall not use the DHS, USCIS or{' '}
          <span className="text-no-wrap">E-Verify</span>, <span className="text-no-wrap">{PROGRAM_NAME}</span> seal,
          insignia, or other visual identities in any manner to imply endorsement of any commercial product or activity
          by DHS, USCIS, <span className="text-no-wrap">E-Verify</span>,{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> or the United States government. Use of these seals,
          insignia or other visual identities without authorization violates federal law (for example, 18 U.S.C. §§ 506,
          701, 1017). Use of <span className="text-no-wrap">{PROGRAM_NAME}</span> or the receipt of information from it
          does not grant any licenses to copyrights, patents, any other intellectual property rights, or the rights to
          any of the materials on the site or sites or materials accessed by use of the site.
        </li>
        <li>
          DHS is the trademark owner and authorized user of the <span className="text-no-wrap">E-Verify</span> and the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> names and logos. Participants may not use these
          trademarked items without the prior written consent of DHS. Unauthorized use may be considered trademark
          infringement, and the participant may be subject to civil or criminal penalties. Participants may request
          permission by submitting a DHS/USCIS licensing agreement (M-795) (
          <a
            href="https://www.e-verify.gov/about-e-verify/trademark-and-logo-usage-guidelines"
            aria-label="Click here to open the Trademark and Logo Usage Guidelines page in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.e-verify.gov/about-e-verify/trademark-and-logo-usage-guidelines
          </a>
          ), and may not use the <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> trademarked items until the licensing agreement has been
          approved by DHS.
        </li>
      </ol>
      <h4>F. Compliance and Privacy</h4>
      <ol>
        <li>
          <span className="text-no-wrap">E-Verify</span> is committed to maintaining the privacy of personally
          identifiable information in accordance with Federal government standards. Descriptions of{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          information privacy protections are available in the DHS <span className="text-no-wrap">E-Verify</span> System
          of Records Notice and Privacy Impact Assessment which can be found at{' '}
          <a
            href="https://www.everify.gov/key-links/our-commitment-to-privacy"
            aria-label="Click here to open the E-Verify Privacy page in a new tab"
            target="_blank"
            rel="noopener noreferrer"
          >
            E-Verify Privacy
          </a>
          .
        </li>
        <li>
          DHS reserves the right to conduct, and the participant agrees to comply with Form I-9 compliance inspections,
          review of Web Services software, and any other monitoring, enforcement or compliance activity authorized by
          law, including site visits, to ensure proper enrollment in and use of{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>.
        </li>
        <li>
          Participation in <span className="text-no-wrap">{PROGRAM_NAME}</span> is not confidential and information may
          be shared as authorized or required by law or policy. A complete list of routine uses for this information is
          available in the DHS <span className="text-no-wrap">E-Verify</span> System of Records Notice.
        </li>
      </ol>
      <h4>G. Modification and Assignment</h4>
      <ol>
        <li>
          These Terms of Service are effective upon the participant’s agreement and shall continue in effect for as long
          as DHS operates <span className="text-no-wrap">{PROGRAM_NAME}</span>, unless modified in writing by the mutual
          consent of all parties.
        </li>
        <li>
          Any and all <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> system enhancements by DHS or SSA, including but not
          limited to <span className="text-no-wrap">E-Verify</span> checking additional data sources and instituting new
          verification policies or procedures, will be covered under these Terms of Service and will not cause the need
          for execution of a new or supplemental Terms of Service that outlines these changes. It is the{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participant’s responsibility to check periodically for
          any changes DHS may make to these Terms of Service.{' '}
          <strong>
            Participants agree to be bound by any such Terms of Service revisions and, additionally, assume the burden
            of continually ensuring compliance with DHS requirements for{' '}
            <span className="text-no-wrap">{PROGRAM_NAME}</span> usage as well as records retention.
          </strong>
        </li>
        <li>
          A participant may not sublicense, assign, or transfer all or any part of its rights or obligations under these
          Terms of Service without prior written notice to <span className="text-no-wrap">E-Verify</span> at{' '}
          <EVerifyEmail />. Any attempt to sublicense, assign, or transfer any of the rights, duties, or obligations
          under these Terms of Service without prior written notice to DHS is void.
        </li>
        <li>
          If any provision of these Terms of Service is held illegal or unenforceable in a judicial proceeding, such
          provision must be severed and will be inoperative, and the remainder of these Terms of Service will remain
          operative and binding.
        </li>
      </ol>
      <h4>H. Termination and Suspension</h4>
      <ol>
        <li>
          A participant may terminate its use of <span className="text-no-wrap">{PROGRAM_NAME}</span> at any time by
          simply ceasing to use the <span className="text-no-wrap">{PROGRAM_NAME}</span> functionality. These Terms of
          Service continue; however, as long as the participant’s <span className="text-no-wrap">E-Verify</span> MOU
          remains effective.
        </li>
        <li>
          DHS may terminate, modify, suspend or discontinue, temporarily or permanently, these Terms of Service (or any
          provision of these Terms of Service) or an <span className="text-no-wrap">{PROGRAM_NAME}</span> participant’s
          access to <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> (or any part thereof) with or without notice at any time
          if DHS deems it necessary because of the requirements of law or policy, or because DHS determines there has
          been a breach of system integrity or security by the <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          participant or any <span className="text-no-wrap">E-Verify</span> user, including unauthorized users,
          transmitting false information, submitting stolen information or uploading counterfeit or altered documents,
          or a failure on the part of any party to comply with established{' '}
          <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
          procedures and/or legal requirements.
        </li>
        <li>
          The participant agrees that DHS will not be liable to the participant or to any third party for any
          termination of these Terms of Service or modification, suspension or discontinuance of the participant’s
          access to <span className="text-no-wrap">E-Verify</span> or{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>, and that DHS is not liable for any data or information
          lost because of discontinuance of service. Termination of participation in{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> may include: (a) suspension, revocation or deletion of
          usernames, passwords and all related information, files and content associated with or inside an account (or
          any part thereof), with or without notice to the participant; and (b) barring further use of{' '}
          <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span>. The
          participant understands that if it is in a State or is party to a contract where{' '}
          <span className="text-no-wrap">E-Verify</span> is required as a condition of business or employment licensing
          or contracting, termination of these Terms of Service by any party may negatively affect the participant’s
          business.
        </li>
      </ol>
      <h4>I. Jurisdiction</h4>
      <ol>
        <li>
          Nothing in these Terms of Service is intended, or should be construed, to create any right or benefit,
          substantive or procedural, enforceable at law by any third party against the United States, its agencies,
          officers, or employees, or against the participant, its agents, officers, or employees.
        </li>
        <li>
          The federal laws of the United States govern the terms, conditions and use of this site, and all{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> participants and any other site users irrevocably consent
          to the exclusive jurisdiction of the federal laws of the United States for any action to enforce these terms,
          conditions, and use of this site. All conduct arising out of or relating to access and use shall be subject to
          the laws of the United States of America regardless of the participant’s or user’s citizenship, residency, or
          location at time of access.
        </li>
        <li>
          Each <span className="text-no-wrap">{PROGRAM_NAME}</span> participant is individually liable and solely
          responsible for defending any civil, criminal, administrative, or contractual claim or action against them
          arising out of or related to these Terms of Service or their use or administration of{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span>, including (but not limited to) any dispute between the
          participant and any other person or entity regarding the applicability of Section 403(d) of IIRIRA to any
          action taken or allegedly taken by the participant.
        </li>
        <li>
          <span className="text-no-wrap">{PROGRAM_NAME}</span> is designed to comply with United States federal laws.{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> should not be viewed, accessed, or used if such activity
          is contrary to law. Participants are responsible for knowing, understanding, and complying with U.S. federal
          laws and the laws of their specific jurisdiction.
        </li>
      </ol>
      <h4>
        J. Special Types of <span className="text-no-wrap">{PROGRAM_NAME}</span> Participants
      </h4>
      <ol>
        <li>
          <strong>Federal Contractors.</strong> In addition to the other applicable requirements in these Terms of
          Service, <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) and agency guidance, Federal Contractors
          and subcontractors required to enroll in and use <span className="text-no-wrap">E-Verify</span> in accordance
          with the Federal Acquisition Regulation (FAR) at 48 C.F.R. Subpart 22.18 and 48 C.F.R. 52.222-54, agree that:
          <ol>
            <li>
              Failure to enroll in and use <span className="text-no-wrap">E-Verify</span> as required may lead to
              account disablement, suspension or termination of participation in{' '}
              <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>,
              and suspension or debarment from Federal contracting. Termination of these Terms of Service or access to{' '}
              <span className="text-no-wrap">E-Verify</span> or <span className="text-no-wrap">{PROGRAM_NAME}</span> for
              any reason may negatively affect the performance of Federal Contractor responsibilities.
            </li>
            <li>
              Compliance with the <span className="text-no-wrap">E-Verify</span> Memorandum of Understanding is a
              performance requirement under the terms of the Federal Contract or subcontract, and as such they consent
              to the release of information relating to <span className="text-no-wrap">E-Verify</span> and{' '}
              <span className="text-no-wrap">{PROGRAM_NAME}</span> use to contracting officers, government auditors or
              other officials authorized to review or enforce the Federal Contractor’s compliance with Federal
              contracting requirements.
            </li>
            <li>
              Upon termination or completion of all Federal contracts and subcontracts that require its participation in{' '}
              <span className="text-no-wrap">E-Verify</span>, the Federal Contractor or subcontractor may terminate its{' '}
              <span className="text-no-wrap">E-Verify</span> MOU by providing written notice to DHS. If a participant
              that is a Federal contractor or subcontractor fails to provide such notice, then that contractor will
              remain an <span className="text-no-wrap">E-Verify</span> and{' '}
              <span className="text-no-wrap">{PROGRAM_NAME}</span> participant, will remain bound by the terms of these
              Terms of Service that apply to non-Federal contractor participants, and will be required to comply with{' '}
              <span className="text-no-wrap">E-Verify</span> and, as applicable,{' '}
              <span className="text-no-wrap">{PROGRAM_NAME}</span> procedures to electronically confirm the employment
              eligibility of all newly hired individuals.
            </li>
          </ol>
        </li>
        <li>
          <strong>Airport Operators.</strong> In addition to the other applicable requirements in these Terms of
          Service, <span className="text-no-wrap">E-Verify</span> user manual(s),{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) and agency guidance, Airport Operators, as
          defined in 49 U.S.C. § 1540.5, agree to:
          <ol>
            <li>
              Comply with the most current version of the <span className="text-no-wrap">{PROGRAM_NAME}</span> User
              Manual Airport Operator provisions and <span className="text-no-wrap">E-Verify</span> Supplemental Guide
              for Airport Operators.
            </li>
            <li>
              Create <span className="text-no-wrap">{PROGRAM_NAME}</span> cases for badging applicants only when
              determining eligibility for unescorted access to any security identification display area of an airport.
            </li>
          </ol>
        </li>
        <li>
          <strong>
            <span className="text-no-wrap">E-Verify</span> Employer Agents.
          </strong>{' '}
          In addition to the other applicable requirements in these Terms of Service,{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> user
          manual(s) and agency guidance, <span className="text-no-wrap">E-Verify</span> Employer Agents agree to:
          <ol>
            <li>
              Provide their clients with training on <span className="text-no-wrap">{PROGRAM_NAME}</span> processes,
              policies, and procedures as well as ongoing <span className="text-no-wrap">{PROGRAM_NAME}</span> training
              as needed, and demonstrate, if requested by DHS, that they have provided training to participant employees
              and clients, respectively, that meets <span className="text-no-wrap">E-Verify</span> standards and
              requirements.
            </li>
            <li>
              DHS is not responsible for providing training to clients of <span className="text-no-wrap">E-Verify</span>{' '}
              or <span className="text-no-wrap">{PROGRAM_NAME}</span> Employer Agents.
            </li>
            <li>
              Update a client company’s <span className="text-no-wrap">{PROGRAM_NAME}</span> profile, to include
              notating the EIN and, if applicable, federal contractor Unique Entity ID (UEI), upon receiving notice from
              a client company that it has received a contract with the FAR{' '}
              <span className="text-no-wrap">E-Verify</span> clause. The <span className="text-no-wrap">E-Verify</span>{' '}
              Employer Agent must update the company’s <span className="text-no-wrap">E-Verify</span> profile within 30
              days of the contract award date.
            </li>
            <li>
              Protect personally identifiable information during transmission to and from the{' '}
              <span className="text-no-wrap">E-Verify</span> Employer Agent when data is transmitted between the{' '}
              <span className="text-no-wrap">E-Verify</span> Employer Agent and its clients.
            </li>
          </ol>
        </li>
        <li>
          <strong>
            Participants using an <span className="text-no-wrap">E-Verify</span> Employer Agent.
          </strong>{' '}
          In addition to the other applicable requirements in these Terms of Service, the{' '}
          <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span> user
          manual(s) and agency guidance, participants authorizing an <span className="text-no-wrap">E-Verify</span>{' '}
          Employer Agent to create <span className="text-no-wrap">{PROGRAM_NAME}</span> cases on their behalf agree to:
          <ol>
            <li>
              Provide the Employer Agent with their company name, address, point of contact names, titles, addresses,
              email addresses and telephone numbers, and promptly notify the Employer Agent if that information changes.
            </li>
            <li>
              Promptly provide, upon request, a copy of the individual’s List A document if one was provided (a U.S.
              passport, a passport card, a Permanent Resident Card (Form I-551) or an Employment Authorization Document
              (Form I-766)) to the <span className="text-no-wrap">E-Verify</span> Employer Agent for the photo matching
              tool.
            </li>
            <li>
              Follow all procedures for changing <span className="text-no-wrap">E-Verify</span> Employer Agents, if
              necessary, as described in the <span className="text-no-wrap">E-Verify</span> and{' '}
              <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) and Quick Reference Guide.
            </li>
            <li>Identify their Employer Agent to DHS and fully cooperate with any request for information.</li>
          </ol>
        </li>
        <li>
          <strong>Participants using Web Services.</strong> In addition to the other applicable requirements in these
          Terms of Service, <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) and agency guidance, participants using a
          Web Services interface agree to:
          <ol>
            <li>
              Construct an interface that complies with the Interface Control Agreement (ICA), these Terms of Service,
              the <span className="text-no-wrap">E-Verify</span> and{' '}
              <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) and agency guidance. If the Web
              Services interface is unavailable to the extent that creating cases could be delayed, the participant will
              instead use the <span className="text-no-wrap">E-Verify</span> browser to complete cases. The participant
              agrees to keep its <span className="text-no-wrap">E-Verify</span> browser login information current.
            </li>
            <li>
              Complete the interface no later than six months after the date of acceptance of these Terms of Service.
              DHS considers the interface to be complete once it has been built pursuant to the most recent Interface
              Control Agreement (ICA), submitted to DHS for testing, and approved for system access. Similarly,
              participants agree to maintain ongoing technical compatibility with{' '}
              <span className="text-no-wrap">E-Verify</span>, including making system updates within the timeframe
              identified by DHS. If the participant cannot build the update within the time specified by the government,
              then its account may be suspended and support for previous releases of{' '}
              <span className="text-no-wrap">E-Verify</span> and <span className="text-no-wrap">{PROGRAM_NAME}</span>{' '}
              may no longer be available
            </li>
            <li>
              Follow the steps for creating <span className="text-no-wrap">{PROGRAM_NAME}</span> cases and processing
              mismatches, as provided in the ICA, these Terms of Service, <span className="text-no-wrap">E-Verify</span>{' '}
              and <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) and agency guidance. This includes
              but is not limited to: providing individuals to be verified with an{' '}
              <span className="text-no-wrap">{PROGRAM_NAME}</span> supplied hyperlink, providing notification when the
              individual has completed Section 1 and document information entry and upload of the{' '}
              <span className="text-no-wrap">{PROGRAM_NAME}</span> process, respectively, providing for notification of
              mismatches and attestation as to examination of documents, properly closing cases, and closing an invalid
              case where appropriate. The participant understands that any failure to make its system or interface
              consistent with <span className="text-no-wrap">{PROGRAM_NAME}</span> procedures can result in DHS
              terminating this agreement and its system access.
            </li>
            <li>
              Conduct testing to ensure that the code is correct and secure and develop effective controls to ensure the
              integrity, accuracy, and reliability of its electronic system. These controls must include a quality
              assurance program that regularly (at least once per year) evaluates the electronic system and includes
              periodic checks of electronically stored information. Participants agree to share the results of their
              regular inspection and quality assurance program with DHS upon request and to cooperate willingly with any
              DHS assessment of its information security and privacy practices.
            </li>
            <li>
              Incorporate error handling logic into their development or software to accommodate and act in a timely
              fashion should an error code be returned.
            </li>
            <li>
              Provide training to any user who accesses <span className="text-no-wrap">{PROGRAM_NAME}</span> on their
              behalf as well as to their clients, if applicable, and demonstrate, if requested by DHS, that is has
              provided training to its participant employees and clients, respectively, that meets{' '}
              <span className="text-no-wrap">E-Verify</span> standards and requirements.
            </li>
            <li>
              Comply with the standards for use and retention of electronic Forms I-9 and electronic audit trails found
              in 8 CFR 274a.2(e)-(i) and <span className="text-no-wrap">{PROGRAM_NAME}</span> guidance.
            </li>
            <li>
              Hold DHS harmless and without liability with respect to the Web Services participant’s development or
              maintenance of any Web Services access system.
            </li>
          </ol>
          <strong>Note for Web Services Software Developers:</strong> DHS does not permit or support Web Services
          software development unless the Web Services participant or Web Services{' '}
          <span className="text-no-wrap">E-Verify</span> Employer Agent is using{' '}
          <span className="text-no-wrap">E-Verify</span> to create cases for its own employees. DHS may terminate access
          of any software developer, with or without notice, who creates or uses an interface that does not comply with
          these Terms of Service, the <span className="text-no-wrap">E-Verify</span> and{' '}
          <span className="text-no-wrap">{PROGRAM_NAME}</span> user manual(s) or agency guidance.
        </li>
      </ol>
      <h4>K. Acknowledgement</h4>
      <p>
        These Terms of Service constitute the full agreement on this subject between DHS and the participant. This
        agreement does not affect any authority, right, responsibility or obligation DHS or the participant would have
        had, or will have, independent of this agreement, under applicable law.
      </p>
      <p>
        The participant understands that any inaccurate statement, representation, data or other information provided to
        DHS may subject the participant, its subcontractors, its employees, or its representatives to: (1) prosecution
        for false statements pursuant to 18 U.S.C. 1001 and/or; (2) immediate termination of this Terms of Service
        agreement and/or; (3) possible debarment or suspension.
      </p>
      <p>
        <strong>
          By accepting these Terms of Service, I represent and attest that I am authorized to accept them and that I
          have read, understand, and agree to abide by them.
        </strong>
      </p>
    </div>
  );
};

export default EvePlusTermsOfService;
